<div class="d-flex flex-row align-items-center" *ngIf="!loading"
    [style.justifyContent]="hideResume ? 'center' : 'space-between'">
    <div class="pagination-info" *ngIf="!hideResume">
        {{ 'pagination_info_1' | translate }}
        <span class="page-strong">{{ currentPage }}</span>
        <span *ngIf="pageAmount > 1">
            {{ 'pagination_info_2' | translate }}
            <span class="page-strong">{{ pageAmount }}</span>
        </span>
    </div>

    <div class="pagination" role="list" aria-label="Pagination">
        <!-- Previous button -->
        <button class="button" type="button" (click)="prevPage()" [disabled]="currentPage <= 1"
            aria-label="Previous page">
            <img src="assets/icons/chevron-left.svg" alt="" class="chevron-icon chevron-icon--left" />
        </button>

        <!-- First page (only for large pagination) -->
        <button *ngIf="pageAmount > 7" class="button" type="button" (click)="goToPage(1)"
            [ngClass]="{ 'button-selected': currentPage === 1 }" aria-label="Page 1">
            1
        </button>

        <!-- Left ellipsis -->
        <span *ngIf="shouldShowLeftEllipsis" class="pagination-ellipsis" aria-hidden="true">…</span>

        <!-- Visible page numbers -->
        <ng-container *ngFor="let page of pagesToShow; trackBy: trackByPage">
            <button class="button" type="button" [ngClass]="{ 'button-selected': page === currentPage }"
                (click)="goToPage(page)" [attr.aria-current]="page === currentPage ? 'page' : null">
                {{ page }}
            </button>
        </ng-container>

        <!-- Right ellipsis -->
        <span *ngIf="shouldShowRightEllipsis" class="pagination-ellipsis" aria-hidden="true">…</span>

        <!-- Last page (only for large pagination) -->
        <button *ngIf="pageAmount > 7" class="button" type="button" (click)="goToPage(pageAmount)"
            [ngClass]="{ 'button-selected': currentPage === pageAmount }" aria-label="Last page">
            {{ pageAmount }}
        </button>

        <!-- Next button -->
        <button class="button" type="button" (click)="nextPage()" [disabled]="currentPage >= pageAmount"
            aria-label="Next page">
            <img src="assets/icons/chevron-left.svg" alt="" class="chevron-icon" />
        </button>
    </div>
</div>